/**
 *
 * https://github.com/diffusion-fi/v2-periphery/blob/main/scripts/config/config.ts
 *
 * When changing this also update: cypress/integration/contracts.ts
 *
 */

const isTesting = false;

const PERIPHERY_TESTNET = {
  factory: '0x3221F1417F92942374ec11097998eBFaC93EAC9b',
  weth9: '0xf531B8F309Be94191af87605CfBf600D71C2cFe0',
  router: '0xeF7Ab5019E763D2c9Eb7b04706939D613a9a0F46',
  mockUSDC: '0xf56dc6695cF1f5c364eDEbC7Dc7077ac9B586068',
  multicall2: '0xeF7Ab5019E763D2c9Eb7b04706939D613a9a0F46',
  miniChef: '0xe4d0165EB7C1aFDB6337468F220D944418F58b96',
  diffusion: '0x554f16d513e1eB2fDf3b8CaAAb50405415Fa405A',
}

const MAINNET_PERIPHERY = isTesting ? {
  factory: '0xF6513a0eA50a6e4C3D70200b9E22C128e6443771',
  weth9: '0x4200000000000000000000000000000000000006',
  router: '0xA830DE16B4d470d37f554E448d956BD9a13F8839',
  multicall2: '0x10B7DE073b514f54E27B71cd267CcE4379bbfac9',
  minichef: '0x545271EeBC65C20a2881cdd3Ea27cCB3756a372B',
  diffusion: '0x408e5547305527D701334B84ea75899219967E68',
} : {
  factory: '0x8937837a0Ee98984EB8199B3384da7a136168154',
  weth9: '0x4200000000000000000000000000000000000006',
  router: '0xBa88b20dD982cF50701cf29755bBC3dfa353821f',
  multicall2: '0x10B7DE073b514f54E27B71cd267CcE4379bbfac9',
  minichef: '0x5D31436532EE6850E4050C46CFCF1D1D9E5CA35a',
  diffusion: '0x7ABf012C7423d3F529b35A74106940F00eCB3c2b',
}

const TESTNET_STABLE_PAIRS: string[] = []

const MAINNET_STABLE_PAIRS: string[] = []

export const MAINNET = {
  ...MAINNET_PERIPHERY,
  stablePairs: MAINNET_STABLE_PAIRS,
  diffusionbar: '0xdf0D02351A3e7A21D3936cf1CFd1ee554Cee0a80',
  airdrop: '0xb9A52744213eA63D57F389622e1d569Bb4705207',
}

export const TESTNET = {
  ...PERIPHERY_TESTNET,
  stablePairs: TESTNET_STABLE_PAIRS,
  airdrop: '0x2F7Ad6172388aED2017FBfA1631724F172360Ab1',
  diffusionbar: '0xe4d0165EB7C1aFDB6337468F220D944418F58b96', // true one is '0x3A5E791405526EFaDf1432Bac8d114B77Da3628c',
}
